import(/* webpackMode: "eager", webpackExports: ["RenderBuilderContent"] */ "/vercel/path0/components/builder.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AddToCartBundle"] */ "/vercel/path0/components/bundles/add-to-cart-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/cart/modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/layout/navbar/mobile-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavbarLink"] */ "/vercel/path0/components/layout/navbar/navbar-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/layout/navbar/navbar-scroll-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchSkeleton","default"] */ "/vercel/path0/components/layout/navbar/search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavbarWrapper"] */ "/vercel/path0/components/layout/NavbarWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Ratings"] */ "/vercel/path0/components/ratings/Ratings.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.0.0-canary.113_react-dom@19.0.0-rc-3208e73e-20240730_react@19.0.0-rc-3208e73e-2024073_4xh4g4q6puzpsjuq53kgwaqj2y/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.0.0-canary.113_react-dom@19.0.0-rc-3208e73e-20240730_react@19.0.0-rc-3208e73e-2024073_4xh4g4q6puzpsjuq53kgwaqj2y/node_modules/next/dist/client/link.js");
